import PropTypes from "prop-types";

// @mui
import { styled, alpha } from "@mui/material/styles";
import {
  Box,
  Stack,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
} from "@mui/material";

// components
import Iconify from "../../../components/iconify";

// Popovers
import AccountPopover from "./AccountPopover";
import LanguagePopover from "./LanguagePopover";
// import Searchbar from "./Searchbar";
// import NotificationsPopover from "./NotificationsPopover";

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

const HEADER_MOBILE = 64;
const HEADER_DESKTOP = 76;

// ----------------------------------------------------------------------
// HEADER
// ----------------------------------------------------------------------

const StyledRoot = styled(AppBar)(({ theme }) => ({
  background: "linear-gradient(90deg, #005B8F 0%, #0085CA 55%, #00A6D6 100%)",

  boxShadow: "0 4px 20px rgba(0, 91, 143, 0.22)",

  border: "none",

  [theme.breakpoints.up("lg")]: {
    width: `calc(100% - ${NAV_WIDTH}px)`,
  },
}));

// ----------------------------------------------------------------------
// TOOLBAR
// ----------------------------------------------------------------------

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,

  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),

  [theme.breakpoints.up("sm")]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },

  [theme.breakpoints.up("lg")]: {
    minHeight: HEADER_DESKTOP,
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
}));

// ----------------------------------------------------------------------
// MENU BUTTON
// ----------------------------------------------------------------------

const MenuButton = styled(IconButton)(() => ({
  width: 42,
  height: 42,

  borderRadius: 12,

  color: "#FFFFFF",

  transition: "all 0.25s ease",

  "&:hover": {
    backgroundColor: "rgba(255,255,255,0.15)",
    transform: "translateY(-1px)",
  },

  "&:active": {
    transform: "scale(0.96)",
  },
}));

// ----------------------------------------------------------------------
// ACTION BUTTON
// ----------------------------------------------------------------------

const ActionButton = styled(IconButton)(() => ({
  width: 42,
  height: 42,

  borderRadius: 12,

  color: "#FFFFFF",

  transition: "all 0.25s ease",

  "&:hover": {
    backgroundColor: "rgba(255,255,255,0.15)",
  },
}));

// ----------------------------------------------------------------------
// PROPS
// ----------------------------------------------------------------------

Header.propTypes = {
  onOpenNav: PropTypes.func,
};

// ----------------------------------------------------------------------
// COMPONENT
// ----------------------------------------------------------------------

export default function Header({ onOpenNav }) {
  return (
    <StyledRoot>
      <StyledToolbar>
        {/* ========================================================= */}
        {/* MENÚ MOBILE */}
        {/* ========================================================= */}

        <MenuButton
          onClick={onOpenNav}
          aria-label="Abrir menú"
          sx={{
            mr: 1.5,
            display: {
              xs: "flex",
              lg: "none",
            },
          }}
        >
          <Iconify icon="eva:menu-2-outline" width={24} height={24} />
        </MenuButton>

        {/* ========================================================= */}
        {/* IDENTIDAD DE LA APLICACIÓN */}
        {/* ========================================================= */}

        <Box
          sx={{
            display: {
              xs: "none",
              sm: "flex",
            },
            alignItems: "center",
            gap: 1.5,
          }}
        >
          {/* Icono */}

          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: "12px",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",

              backgroundColor: "rgba(255,255,255,0.14)",

              border: "1px solid rgba(255,255,255,0.18)",

              backdropFilter: "blur(10px)",
            }}
          >
            <Iconify
              icon="mdi:shield-check-outline"
              width={24}
              height={24}
              color="#FFFFFF"
            />
          </Box>

          {/* Texto */}

          <Box>
            <Typography
              sx={{
                color: "#FFFFFF",
                fontSize: {
                  sm: "0.9rem",
                  md: "0.95rem",
                },
                fontWeight: 700,
                lineHeight: 1.2,
                letterSpacing: "0.2px",
              }}
            >
              Huella de Confianza
            </Typography>

            <Typography
              sx={{
                color: "rgba(255,255,255,0.72)",
                fontSize: "0.68rem",
                lineHeight: 1.2,
                mt: 0.3,
              }}
            >
              Plataforma de certificación
            </Typography>
          </Box>
        </Box>

        {/* ========================================================= */}
        {/* ESPACIO */}
        {/* ========================================================= */}

        <Box sx={{ flexGrow: 1 }} />

        {/* ========================================================= */}
        {/* ACCIONES */}
        {/* ========================================================= */}

        <Stack
          direction="row"
          alignItems="center"
          spacing={{
            xs: 0.5,
            sm: 1,
          }}
        >
          {/* ===================================================== */}
          {/* BUSCADOR */}
          {/* ===================================================== */}

          {/*
          <Searchbar />
          */}

          {/* ===================================================== */}
          {/* NOTIFICACIONES */}
          {/* ===================================================== */}

          {/*
          <ActionButton aria-label="Notificaciones">
            <Iconify
              icon="eva:bell-outline"
              width={23}
              height={23}
            />
          </ActionButton>

          <NotificationsPopover />
          */}

          {/* ===================================================== */}
          {/* IDIOMA */}
          {/* ===================================================== */}

          <Box
            sx={{
              "& button": {
                color: "#FFFFFF !important",
              },

              "& svg": {
                color: "#FFFFFF",
              },
            }}
          >
            <LanguagePopover />
          </Box>

          {/* ===================================================== */}
          {/* CUENTA */}
          {/* ===================================================== */}

          <Box
            sx={{
              ml: {
                xs: 0,
                sm: 0.5,
              },

              pl: {
                xs: 0,
                sm: 1,
              },

              borderLeft: {
                xs: "none",
                sm: "1px solid rgba(255,255,255,0.18)",
              },

              "& button": {
                color: "#FFFFFF !important",
              },
            }}
          >
            <AccountPopover />
          </Box>
        </Stack>
      </StyledToolbar>
    </StyledRoot>
  );
}
